module.exports = fox._r("images/photo-example.jpg", __webpack_public_path__ + "images/photo-example.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/photo-example.jpg
// module id = 1023
// module chunks = 4